import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";

type ComingSoonProps = {
    counterDate: string; // ISO, es. 2026-05-27T09:00:00+02:00
    title?: string;
};

type TimeLeft = {
    days: number;
    hours: number;
    minutes: number;
    seconds: number;
    expired: boolean;
};

const getTimeLeft = (target: number): TimeLeft => {
    const diff = target - Date.now();
    if (diff <= 0) {
        return { days: 0, hours: 0, minutes: 0, seconds: 0, expired: true };
    }
    return {
        days: Math.floor(diff / 86400000),
        hours: Math.floor((diff / 3600000) % 24),
        minutes: Math.floor((diff / 60000) % 60),
        seconds: Math.floor((diff / 1000) % 60),
        expired: false,
    };
};

const pad = (n: number) => String(n).padStart(2, "0");

const ComingSoon: React.FC<ComingSoonProps> = ({ counterDate, title }) => {
    const target = new Date(counterDate).getTime();
    const [timeLeft, setTimeLeft] = useState<TimeLeft>(() => getTimeLeft(target));

    useEffect(() => {
        const tick = () => {
            const next = getTimeLeft(target);
            setTimeLeft(next);
            // Quando scade, ricarica: NewsDetail rivaluterà isComingSoon
            // e mostrerà il contenuto reale della news.
            if (next.expired) {
                window.location.reload();
            }
        };
        const interval = setInterval(tick, 1000);
        return () => clearInterval(interval);
    }, [target]);

    const units = [
        { label: "Days", value: timeLeft.days },
        { label: "Hours", value: timeLeft.hours },
        { label: "Minutes", value: timeLeft.minutes },
        { label: "Seconds", value: timeLeft.seconds },
    ];

    return (
        <div
            className="relative w-full h-screen overflow-hidden bg-black"
            style={{
                backgroundImage: "url('/news/coming-soon-bg.png')",
                backgroundSize: "cover",
                backgroundPosition: "center",
            }}
        >


            <Helmet>
                <title>Coming Soon | Revolv Space</title>
                <meta name="description" content="Announcement coming soon from Revolv Space." />
            </Helmet>

            {/* Overlay scuro per leggibilità sopra il background */}
            <div className="absolute inset-0 bg-black bg-opacity-60" />

            {/* Logo centrato in alto */}
            <div className="absolute top-0 left-0 right-0 flex justify-center pt-40 z-10">
                <img src="/logo.png" alt="Revolv Space" className="h-20 w-auto" />
            </div>

            {/* Contenuto centrale */}
            <div className="relative z-10 h-full flex flex-col items-center justify-center px-6 text-center">
                <h1 className="text-white font-bold uppercase tracking-widest text-2xl md:text-4xl lg:text-5xl mb-12">
                    Announcement Coming Soon…
                </h1>

                {/* Countdown */}
                <div className="flex gap-4 md:gap-8">
                    {units.map((unit) => (
                        <div key={unit.label} className="flex flex-col items-center">
              <span
                  className="font-bold text-4xl md:text-6xl lg:text-7xl tabular-nums"
                  style={{
                      background: "linear-gradient(90deg, #00858F 0%, #E6007E 100%)",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                      backgroundClip: "text",
                  }}
              >
                {pad(unit.value)}
              </span>
                            <span className="text-white text-opacity-60 uppercase tracking-widest text-xs md:text-sm mt-2">
                {unit.label}
              </span>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default ComingSoon;